export const PAGINATION = {
  defaultValues: {
    page: 1,
    limit: 50,
  },
};
